const theme = {
  token: {
    colorPrimary: '#a87912',
    colorLink: '#8a6416',
    colorText: '#252b32',
    colorTextSecondary: '#5f6974',
    colorBgLayout: '#f4f5f7',
    colorBorder: '#dce0e4',
    colorSuccess: '#39745b',
    colorSuccessBg: '#f1f7f3',
    colorSuccessBorder: '#d6e6db',
    colorInfo: '#406c91',
    colorInfoBg: '#f3f7fb',
    colorInfoBorder: '#d9e4ed',
    colorWarningBg: '#fff9eb',
    colorWarningBorder: '#e8d9b4',
    colorErrorBg: '#fff4f2',
    colorErrorBorder: '#f0d5ce',
    colorWarning: '#a87912',
    colorError: '#b84343',
    borderRadius: 6,
    fontSize: 14,
    controlHeight: 36,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
  },
  components: {
    Button: {
      colorPrimary: '#d9b451',
      colorPrimaryHover: '#e4c36c',
      colorPrimaryActive: '#c7a13e',
      primaryColor: '#252b32',
      primaryShadow: 'none',
      defaultShadow: 'none',
      defaultHoverColor: '#8a6416',
      defaultHoverBorderColor: '#a87912',
      defaultActiveColor: '#604a1d',
      defaultActiveBorderColor: '#8a6416',
    },
    Table: {
      headerBg: '#f5f6f7',
      headerColor: '#5f6974',
      rowSelectedBg: '#eef0f3',
      rowSelectedHoverBg: '#e5e8ec',
      cellPaddingBlockSM: 8,
    },
    Menu: {
      itemSelectedBg: '#e2e5e9',
      itemSelectedColor: '#252b32',
      itemBorderRadius: 5,
    },
    Tabs: {
      inkBarColor: '#a87912',
      itemSelectedColor: '#8a6416',
      titleFontSize: 14,
    },
    Card: { headerFontSize: 16 },
  },
};
export default theme;
